module.exports = __webpack_public_path__ + "static/media/bear4.0925605e.PNG";